import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { CatalogItem } from '../../../../../redux/api/fymAPI.types';
import { releaseArtworkUrl, windowPreviewArtworkPx } from '../../studio/aiReel/releaseArtworkUrl';
import { daysToRelease } from '../../studio/studioRules';
import { themeMessages } from './themeMessages';

export interface ThemeStillSong {
  artworkUrl: string | undefined;
  title: string;
  artist: string;
  /** "Pre-save now" before the release day, else "Out now" (design q2). */
  kicker: string;
}

/** The facts of a song that a theme still shows. */
export function useThemeStillSong(item: CatalogItem): ThemeStillSong {
  const intl = useIntl();
  return useMemo(() => {
    const days = daysToRelease(item.releaseDate, new Date());
    const isBefore = days !== null && days > 0;
    return {
      // Sized for the biggest preview of this screen, not 640 px on a phone (QA mob-7).
      artworkUrl: releaseArtworkUrl(item, windowPreviewArtworkPx()),
      title: item.title,
      artist: item.artistName,
      kicker: intl.formatMessage(isBefore ? themeMessages.kickerPreSave : themeMessages.kickerOutNow),
    };
  }, [intl, item]);
}
